import React, { useState, useEffect, useRef } from "react";
import { instance } from "../../axios";
import { TableZero, PageHeader, UiButton, UiDatePicker, UiClientSelect, UiItemSelect, InLoader, OverlayLoader, titleCase, UiInput, UiSelect, Avatar, PageError, Toastcontent, BgLoader } from "../../ui";
import { useForm, useFieldArray, get, Controller } from 'react-hook-form';
import { useNavigate, useParams } from "react-router-dom";
import { Link, useLocation } from "react-router-dom"
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useStore } from "../../state.js";
import { Helmet } from "react-helmet";
import queryString from 'query-string';
import { CSVLink, CSVDownload } from "react-csv";
import Swal from "sweetalert2";
import { toast } from "react-toastify";
import { MdOutlineDragHandle } from 'react-icons/md';
import { Dropdown, Popconfirm, Menu } from 'antd';
import { Table } from 'antd';
import { DropdownItem } from '@atlaskit/dropdown-menu';
import { getStorage, setStorage, updateFilterUrl, rupees } from "../../helper.js";
import {
  sortableContainer,
  sortableElement,
  sortableHandle,
} from 'react-sortable-hoc';

const SortableContainer = sortableContainer(({ children }) => {
  return <div className="">{children}</div>;
});

const DragHandle = sortableHandle(() => (
  <span className="h2 pe-2 mb-0 text-secondary">
    <MdOutlineDragHandle />
  </span>
));

const SortableItem = sortableElement((value) => {
  return (
    <div className="d-flex pitable bg-white" style={{ minWidth: '700px' }} {...value} />
  );
});



export default function Purchase() {
  let { id } = useParams();
  let navigate = useNavigate();
  const location = useLocation();
  const [loader, showLoader] = useState(false);
  const parsed = queryString.parse(location.search);
  const [state, setState] = useState({ count: 0 });

  const inputRef = useRef(null);


  const schema = yup.object().shape({
    date: yup.string().nullable().required('Date is required'),
    series: yup.string().nullable().required('Series is required'),
    num: yup.string().nullable().required('Voucher number is required'),
    account: yup.mixed().nullable().required('Party is required'),
    pos: yup.string().nullable().required('State is required'),
    staff: yup.mixed().nullable().required('Staff is required'),

    entry: yup.array().of(
      yup.object().shape({
        item: yup.mixed().nullable().required('Item is required'),

        qty: yup.string().nullable().matches(/^[0-9]+$/, "Enter qty").min(0, 'Negative value not allowed'),
        rate: yup.string().nullable().matches(/^[0-9.]+$/, "Enter rate").min(0, 'Negative value not allowed'),
        amount: yup.string().nullable().matches(/^[0-9.]+$/, "Enter amount").min(0, 'Negative value not allowed'),
        tax: yup.string().nullable().required('Tax is required'),

      }, []),
    ),


    bill_sundry: yup.array().of(
      yup.object().shape({
        account: yup.mixed().nullable().required('Account is required'),
        amount: yup.string().nullable().matches(/^[-0-9.]+$/, "Enter amount").min(0, 'Negative value not allowed'),

      }, []),


    ),



  }, [['opening_balance', 'opening_balance']]);
  const selectRefs = useRef([]);
  const insertEntry = () => {
    append({ item: null, credit: null, debit: null, narration: null });

    setTimeout(() => {
      const lastIndex = fields.length;
      if (selectRefs.current[lastIndex]?.focus) {
        selectRefs.current[lastIndex].focus();
      }
    }, 10);
  };


  const {
    register,
    handleSubmit,
    control,
    watch,
    unregister,
    getValues,
    setValue,
    resetField,
    formState: { errors },
    reset,
  } = useForm({
    resolver: yupResolver(schema),
  });


  const fetchData = () => {
    instance
      .get("/get_purchase?id=" + id)
      .then(function (response) {
        setState(response.data)

        if (id == 'new') {
          reset({ ...response.data.voucher, date: getStorage('last_date'), staff: JSON.parse(getStorage('staff')) })
        } else {
          reset(response.data.voucher)
        }
      })
      .catch(function (error) { })
      .then(function () { });
  }


  useEffect(() => {
    fetchData();
  }, [location]);


  const numSeries = (e) => {
    var arr = state.series.filter((item) => item.value == e)[0];
    if (arr.num) {
      resetField('num', { defaultValue: arr.num })
    }
  }

  const handleDelete = (id) => {
    var tid = id.toString();

    showLoader(true)
    instance
      .get("/delete_voucher?type=Purchase&id=" + tid)
      .then(function (response) {
        showLoader(false)
        if (response.data.status == 'success') {
          navigate(-1, { replace: true });
          toast(response.data.msg, { type: "success" });
        } else {
          toast(response.data.msg, { type: "error" });
        }
      })
  }

  const calcTotal = (index) => {
    const qty = getValues(`entry.${index}.qty`);
    const price = getValues(`entry.${index}.rate`);
    const taxRate = getValues(`entry.${index}.tax`);
    const taxAmount = ((price * qty * taxRate) / 100);
    const amount = (price * qty) + taxAmount;
    setValue(`entry.${index}.amount`, amount.toFixed(2));
    setValue(`entry.${index}.tax_amount`, taxAmount.toFixed(2));
    calcGrandTotal();
  };


  const fetchBalance = (id, date, i) => {
    instance
      .get("/fetch_balance?type=item&id=" + id + "&date=" + date)
      .then(function (response) {
        console.log(response.data)
        setValue(`entry.${i}.balance`, response.data.balance);

      })
      .catch(function (error) { })
      .then(function () { });
  }


  const calcGrandTotal = () => {
    const grandtotal = getValues('entry').reduce((sum, field) => {
      return sum + (parseFloat(field.amount) || 0);
    }, 0);

    const tax_total = getValues('entry').reduce((sum, field) => {
      return sum + (parseFloat(field.tax_amount) || 0);
    }, 0);

    const bill_sundry_total = getValues('bill_sundry').reduce((sum, field) => {
      return sum + (parseFloat(field.amount) || 0);
    }, 0);

    const qty_total = getValues('entry').reduce((sum, field) => {
      return sum + (parseInt(field.qty) || 0);
    }, 0);



    setState((prev) => ({ ...prev, subtotal: (grandtotal - tax_total), tax_total: tax_total, qty_total: qty_total, grandtotal: (grandtotal + bill_sundry_total) }));
  }


  const SaveVoucher = (e) => {

    showLoader(true);
    instance({
      method: 'post',
      url: '/update_purchase',
      data: e,
      headers: { 'Content-Type': 'application/json' },
    })
      .then(function (response) {
        showLoader(false);
        if (response.data.status === 'error') {
          toast(response.data.msg, { type: 'error' });
        }
        if (response.data.status === 'success') {
          toast(response.data.msg, { type: 'success' });
          if (id == 'new') {
            navigate("/purchase/new", { replace: true });
            reset();
            if (inputRef.current) {
              inputRef.current.input.focus();
            }
          } else {
            navigate(-1, { replace: true });
          }
        }
      })
      .catch(function (response) { });
  };


  const onSubmitHandler = async (data) => {
    console.log(data)
    SaveVoucher(data);
  };

  const { fields, append, move, remove } = useFieldArray({
    control,
    name: 'entry',
  });

  const { fields: fields1, append: append1, move: move1, remove: remove1 } = useFieldArray({
    control,
    name: 'bill_sundry',
  });


  const entryWatch = watch('entry', fields);
  const bsWatch = watch('bill_sundry', fields1);

  useEffect(() => {
    calcGrandTotal();
  }, [entryWatch, bsWatch]);
  const onSortEnd = ({ oldIndex, newIndex }) => {
    move(oldIndex, newIndex)
  };
  if (state.status == 'error') {
    return (
      <PageError msg={state.msg} code={state.code} />
    )
  }


  return (
    <>
      <Helmet>
        <title>
          Purchase
        </title>
      </Helmet>
      <div>
        <div>
          <PageHeader title="Purchase" >
            {id == 'new' ? null :
              <Popconfirm
                title="Delete?"
                description="Are you sure to delete this?"
                onConfirm={() => handleDelete(id)}
                okText="Yes"
                cancelText="No"
              >
                <button className="btn btn-outline-danger btn-sm me-2" >Delete</button>
              </Popconfirm>
            }


          </PageHeader>

          <OverlayLoader visible={loader} />
          {state.status ?
            <div className="card card-default position-relative">
              <div className="card-body">
                <div className='row'>
                  <div className='col-md-2'>
                    <Controller

                      name="date"
                      control={control}
                      render={({
                        field: { onChange, onBlur, value, name, ref },
                        fieldState: { invalid, isTouched, isDirty, error },
                        formState,
                      }) => (
                        <UiDatePicker
                          required={true}
                          label="Date"
                          onChange={(date) => { onChange(date); setStorage("last_date", date) }}
                          // maxDate={parse(duedateWatch, "dd-MM-yyyy", new Date())}
                          default_val={value}
                          message={errors.date?.message}
                          dateFormat="dd-MM-yyyy"
                          ref={(e) => {
                            ref(e)
                            inputRef.current = e
                          }}
                          name={name}



                        />
                      )}
                    />
                  </div>
                  <div className='col-md-2'>
                    <UiSelect
                      name='series'
                      required={true}
                      label="Series"
                      message={errors.series?.message}
                      options={state.series}
                      {...register(`series`, { onChange: (e) => { numSeries(e.target.value) } })}
                    />
                  </div>
                  <div className='col-md-2'>
                    <UiInput
                      name={`num`}
                      required={true}
                      label="Number"
                      {...register(`num`)}
                      message={errors.num?.message}
                    />
                  </div>
                  <div className="col-md-4">
                    <Controller
                      name={`account`}
                      control={control}
                      render={({ field }) => (

                        <UiClientSelect
                          {...field}
                          required={true}
                          className=""
                          category={[1, 2]}
                          fetch_onload
                          message={errors.account?.message}
                          label="Party"
                          onChange={(value, option) => {
                            field.onChange(value);
                            console.log(option.state)
                            setValue(`pos`, option.state);
                            //calcTotal(i);
                          }}
                        />

                      )}
                    />
                  </div>
                  <div className='col-md-2'>
                    <UiSelect
                      name='pos'
                      label="Place of Supply"
                      required={true}
                      message={errors.pos?.message}
                      //defaultValue={value.machine}
                      options={state.states}
                      {...register(`pos`)}
                    />
                  </div>
                </div>



                <p className="fs-5 fw-bold">Items</p>
                <div className="table-responsive" >
                  <div className="d-flex pitable bg-white" style={{ minWidth: '700px' }} >
                    <div className={`col1 border border-end-0 border-start-0`} style={{ width: '50px' }}>
                    </div>
                    <div className="col border border-end-0 p-1" style={{ minWidth: '200px' }}>
                      Item

                    </div>
                    <div className="col1 border border-end-0 p-1" style={{ width: '110px' }}>
                      Qty.
                    </div>
                    <div className="col1 border border-end-0 p-1" style={{ width: '110px' }}>
                      Rate
                    </div>
                    <div className="col1 border border-end-0 p-1" style={{ width: '110px' }}>
                      GST %
                    </div>
                    <div className="col1 border border-end-0 p-1" style={{ width: '110px' }}>
                      Amount
                    </div>


                    <div className="col1 border border-end-0 text-center p-1" style={{ width: '45px' }}>
                    </div>
                  </div>
                  <SortableContainer onSortEnd={onSortEnd} useDragHandle>
                    {fields.map((val, i) => (
                      <SortableItem key={i} index={i}>
                        <div className={`col1 border border-end-0 border-start-0`} style={{ width: '50px' }}>
                          <DragHandle />
                        </div>
                        <div className="col border border-end-0 p-1" style={{ minWidth: '200px' }}>
                          <Controller
                            key={`item-${val.id}`}
                            name={`entry.${i}.item`}
                            control={control}

                            render={({ field }) => (

                              <UiItemSelect
                                {...field}
                                required={true}
                                parentClass="mb-1"
                                fetch_onload
                                ref={(el) => {
                                  field.ref(el);
                                  selectRefs.current[i] = el;
                                }}
                                className=""
                                message={errors.entry?.[i]?.item?.message}
                                label=""
                                onChange={(value, option) => {
                                  field.onChange(value);
                                  setValue(`entry.${i}.tax`, option.gst);
                                  calcTotal(i);
                                  fetchBalance(value.value, getValues('date'), i)
                                }}
                              />

                            )}
                          />
                          <div className='text-end'><small >{entryWatch[i]?.balance}</small></div>
                        </div>

                        <div className="col1 border border-end-0 p-1" style={{ width: '110px' }}>

                          <UiInput
                            name={`entry.${i}.qty`}
                            {...register(`entry.${i}.qty`, { onChange: (e) => { calcTotal(i); } })}
                            parentClass="mb-0"
                            message={errors.entry?.[i]?.qty?.message}
                            noerror={true}
                            title={errors.entry?.[i]?.qty?.message}

                          />
                        </div>
                        <div className="col1 border border-end-0 p-1" style={{ width: '110px' }}>

                          <UiInput
                            name={`entry.${i}.rate`}
                            {...register(`entry.${i}.rate`, { onChange: (e) => calcTotal(i) })}
                            parentClass="mb-0"
                            message={errors.entry?.[i]?.rate?.message}
                            noerror={true}
                            title={errors.entry?.[i]?.rate?.message}
                          />
                        </div>

                        <div className="col1 border border-end-0 p-1" style={{ width: '110px' }}>

                          <UiSelect
                            name={`entry.${i}.tax`}
                            {...register(`entry.${i}.tax`, { onChange: (e) => calcTotal(i) })}
                            parentClass="mb-0"
                            message={errors.entry?.[i]?.tax?.message}
                            noerror={true}
                            options={[0, 5, 12, 18, 28]}
                          />
                          <UiInput
                            name={`entry.${i}.tax_amount`}
                            {...register(`entry.${i}.tax_amount`)}
                            type="hidden"
                          />
                        </div>
                        <div className="col1 border border-end-0 p-1" style={{ width: '110px' }}>

                          <UiInput
                            name={`entry.${i}.amount`}
                            {...register(`entry.${i}.amount`, { onChange: (e) => calcTotal() })}
                            parentClass="mb-0"
                            message={errors.entry?.[i]?.amount?.message}
                            noerror={true}
                            title={errors.entry?.[i]?.amount?.message}
                          />
                        </div>



                        <div className="col1 border border-end-0 text-center p-1" style={{ width: '45px' }}>
                          <UiButton className="btn btn-outline-danger" onClick={() => remove(i)} icon="delete"> </UiButton>
                        </div>
                      </SortableItem>
                    ))}
                  </SortableContainer>
                  <div className="d-flex pitable bg-white" style={{ minWidth: '700px' }} >
                    <div className={`col1 border border-end-0 border-start-0`} style={{ width: '50px' }}>
                    </div>
                    <div className="col border border-end-0 p-1" style={{ minWidth: '200px' }}>
                      Total

                    </div>
                    <div className="col1 border border-end-0 p-1" style={{ width: '110px' }}>
                      {state.qty_total}
                    </div>
                    <div className="col1 border border-end-0 p-1" style={{ width: '110px' }}>

                    </div>
                    <div className="col1 border border-end-0 p-1" style={{ width: '110px' }}>

                    </div>
                    <div className="col1 border border-end-0 p-1" style={{ width: '110px' }}>

                    </div>


                    <div className="col1 border border-end-0 text-center p-1" style={{ width: '45px' }}>
                    </div>
                  </div>
                </div>

                <div className="text-center mt-3">
                  <UiButton className="btn btn-light" onClick={() => insertEntry()} title="Add Item" icon="add"> </UiButton>
                </div>





                <div className="row">
                  <div className="col-sm-8">
                  </div>
                  <div className="col-sm-4">
                    <table className="table">
                      <tbody>

                        <tr>
                          <td>Sub Total</td><td>{rupees(state.subtotal)}</td>
                        </tr>
                        <tr>
                          <td>Tax</td><td>{rupees(state.tax_total)}</td>
                        </tr>


                        {fields1.map((val, i) => (
                          <tr key={i} index={i} >

                            <td style={{ width: '150px' }}>
                              <Controller
                                name={`bill_sundry.${i}.account`}
                                control={control}
                                render={({ field }) => (

                                  <UiClientSelect
                                    {...field}
                                    required={true}
                                    fetch_onload
                                    parentClass="mb-1"
                                    category={[22, 23]}
                                    className=""
                                    message={errors.bill_sundry?.[i]?.account?.message}
                                    label=""
                                    onChange={(value, option) => {
                                      field.onChange(value);
                                      setValue(`bill_sundry.${i}.rate`, option.selling_price);
                                      calcTotal(i);
                                    }}
                                  />

                                )}
                              />
                            </td>


                            <td >
                              <div className="d-flex">
                                <UiInput
                                  name={`bill_sundry.${i}.amount`}
                                  {...register(`bill_sundry.${i}.amount`, { onChange: (e) => calcTotal() })}
                                  parentClass="mb-0"
                                  message={errors.bill_sundry?.[i]?.amount?.message}
                                  noerror={true}
                                  title={errors.bill_sundry?.[i]?.amount?.message}
                                />
                                <UiButton className="btn btn-outline-danger ms-1" onClick={() => remove1(i)} icon="delete"> </UiButton>
                              </div>
                            </td>




                          </tr>
                        ))}
                        <tr>
                          <td colSpan={2}>

                            <div className="text-center">
                              <UiButton className="btn btn-light btn-sm" onClick={() => append1({})} title="" icon="add"> </UiButton>
                            </div>
                          </td>
                        </tr>

                        <tr>
                          <td>Grand Total</td><td>{rupees(state.grandtotal)}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>


                  <div className='row mb-3'>
                    <div className="col-md-4">
                      <UiInput

                        label="Narration"
                        name={`narration`}
                        {...register("narration", { onBlur: (e) => setValue('narration', titleCase(e.target.value)) })}
                        message={errors.narration?.message}
                        title={errors.narration?.message}
                      />
                      <Controller
                        name={`staff`}
                        control={control}
                        render={({ field }) => (

                          <UiClientSelect
                            icol="8"
                            category={[26]}
                            lcol="4"
                            {...field}
                            parentClass="mb-1"
                            className=""
                            fetch_onload
                            message={errors.staff?.message}
                            label="Staff"
                            onChange={(e) => { field.onChange(e); setStorage("staff", e.value) }}

                          />

                        )}
                      />
                    </div>
                  </div>

                  {state.voucher.created_by && <p>Created By: {state.voucher.created_by} on {state.voucher.created_on}</p>}
                  {state.voucher.updated_by && <p>Updated By: {state.voucher.updated_by} on {state.voucher.updated_on}</p>}
                  <form id="jvform" onSubmit={handleSubmit(onSubmitHandler)}>
                    <input type="hidden" value={id} name="id" {...register("id")} />
                    <UiButton type="submit" className="btn btn-primary" disabled={fields.length == 0} title="Save">

                    </UiButton>
                  </form>
                </div>
              </div>
            </div>
            : <BgLoader />
          }
        </div>
      </div>
    </>
  );
}
